import { createBrowserRouter, type RouteObject } from "react-router";
import { BookingPage } from "./pages/BookingPage";
import { LegacyManageLink } from "./pages/LegacyManageLink";
import { ManagePage } from "./pages/ManagePage";
import { NotFound } from "./pages/NotFound";
import { RouteErrorBoundary } from "./pages/RouteErrorBoundary";
import { WaitlistStatusPage } from "./pages/WaitlistStatusPage";

/**
 * The widget's routes. `/v/:venueSlug` is the ONE real surface (standalone page + iframe/island
 * target); everything else is a non-indexable not-found shell. Deep links under `/v/*` are SPA-fallback
 * routed by Cloudflare Pages (public/_routes.json), so the standalone URL shape stays stable
 * (GOOGLE-READINESS.md §1 phase 2 deep-links to it). The array is shared: the app builds a browser
 * router from it; the island builds a memory router (it mounts on a storefront at an arbitrary path).
 */
export const routes: RouteObject[] = [
  {
    path: "/v/:venueSlug",
    element: <BookingPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/m/:venueId/:token",
    element: <ManagePage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/m/:token",
    element: <LegacyManageLink />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/manage/*",
    element: <LegacyManageLink />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/w/:venueId/:token",
    element: <WaitlistStatusPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "*",
    element: <NotFound />,
    errorElement: <RouteErrorBoundary />,
  },
];

export const router = createBrowserRouter(routes);
